import { render, staticRenderFns } from "./SalesHistory.vue?vue&type=template&id=22f5b101&scoped=true&"
import script from "./SalesHistory.vue?vue&type=script&lang=js&"
export * from "./SalesHistory.vue?vue&type=script&lang=js&"
import style0 from "./SalesHistory.vue?vue&type=style&index=0&id=22f5b101&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f5b101",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VBtnToggle,VCol,VDataTable,VIcon,VSelect,VTextField})
